import { EditorModes, PcbNodeTypes, ReviewType } from "@buildwithflux/models";
import { isDescendantOfElement } from "../../nodes";
import { PcbLayoutRuleCompiler } from "../../pcb";
import { getProblemTypeKeyFromReviewType } from "../types";
export class ImportantOverrideValidator {
    reviewType = ReviewType.DesignRuleCheckComponentOverrides;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    async checkForProblems({ pcbLayoutRuleSets, pcbLayoutNodes }) {
        const ruleSetsWithImportantProblems = Object.values(pcbLayoutRuleSets)
            .filter((ruleSet) => Object.values(ruleSet.rules).filter(PcbLayoutRuleCompiler.isRuleImportant).length > 0)
            .filter((ruleSet) => {
            // Extract the affected element uid from the selector
            const nodeUidWithoutFirstPart = ruleSet.selector.split("[uid=")[1];
            let nodeUid = nodeUidWithoutFirstPart?.substring(0, nodeUidWithoutFirstPart.length - 1);
            if (nodeUid?.startsWith('"')) {
                nodeUid = nodeUid.substring(1);
            }
            if (nodeUid?.endsWith('"')) {
                nodeUid = nodeUid && nodeUid.substring(0, nodeUid.length - 1);
            }
            if (nodeUid && pcbLayoutNodes[nodeUid]) {
                const node = pcbLayoutNodes[nodeUid];
                return node.type !== PcbNodeTypes.element && isDescendantOfElement(pcbLayoutNodes, nodeUid);
            }
            return false;
        })
            .map((ruleSet) => {
            // We try to extract the affected element uid from the selector
            // This is supposed to work with the important rules generated automatically by dragging
            const nodeUidWithoutFirstPart = ruleSet.selector.split("[uid=")[1];
            let nodeUid = nodeUidWithoutFirstPart?.substring(0, nodeUidWithoutFirstPart.length - 1);
            if (nodeUid?.startsWith('"')) {
                nodeUid = nodeUid.substring(1);
            }
            if (nodeUid?.endsWith('"')) {
                nodeUid = nodeUid && nodeUid.substring(0, nodeUid.length - 1);
            }
            const affectedUid = nodeUid && pcbLayoutNodes[nodeUid] ? [{ type: "pcbLayoutNode", uid: nodeUid }] : [];
            return {
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${ruleSet.uid}`,
                affectedItems: [{ type: "ruleSet", uid: ruleSet.uid }, ...affectedUid],
                affectedViews: [EditorModes.pcb],
            };
        });
        const localRulesWithImportantProblems = Object.values(pcbLayoutNodes)
            .filter((node) => {
            return node.type !== PcbNodeTypes.element && isDescendantOfElement(pcbLayoutNodes, node.uid);
        })
            .filter((node) => 
        // See TEMP_patchMissingButRequiredDocumentData
        Object.values(node.pcbNodeRuleSet || {}).filter(PcbLayoutRuleCompiler.isRuleImportant).length > 0)
            .map((node) => {
            return {
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${node.uid}`,
                affectedItems: [{ type: "pcbLayoutNode", uid: node.uid }],
                affectedViews: [EditorModes.pcb],
            };
        });
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: [...ruleSetsWithImportantProblems, ...localRulesWithImportantProblems],
        };
    }
}
//# sourceMappingURL=ImportantOverrideValidator.js.map